import { IBranchNode, ISelectableNode } from '../types';
import { EntityMenuName, NodeWithCount } from '../EntitySelectionPanelUI';
import { MenuItemIcon } from './NodeIcon';
import React, { forwardRef, useCallback } from 'react';
import KubitTooltip from '../../../KubitTooltip';
import { areNodesEqual } from '../utils';
import { SvgIcon } from '../../../Icon';

interface IProps {
  indent: number;
  selectedNode: ISelectableNode;
  onSelectNode: (node: IBranchNode) => void;
  node: IBranchNode;
}

const BranchNode = forwardRef<HTMLDivElement, IProps>(
  ({ node, onSelectNode, selectedNode, indent }, ref) => {
    const selectHandler = useCallback(
      () => onSelectNode(node),
      [node, onSelectNode],
    );

    const selected = areNodesEqual(node, selectedNode);

    return (
      <KubitTooltip content={node.name} placement="bottom-start">
        <NodeWithCount
          $selected={selected}
          onClick={selectHandler}
          ref={ref}
          $indent={indent}
        >
          <MenuItemIcon node={node} />
          <EntityMenuName>{node.name}</EntityMenuName>
          <span>{node.count}</span>
          <SvgIcon
            name="caret-right-fill"
            width={12}
            height={12}
            customFill="currentColor"
          />
        </NodeWithCount>
      </KubitTooltip>
    );
  },
);
export default BranchNode;
